import React from 'react';
import { Banknote, AlertCircle, Circle, Bell } from 'lucide-react';
import { PaymentStatus }  from '@dutchinvoice/types';
import { useTranslation } from '../../hooks/useTranslation';

const STATUS_CONFIG = {
  unpaid: {
    icon: Circle,
    textKey: 'payment.status.unpaid',
    className: 'bg-gray-100 text-gray-600 hover:bg-gray-200'
  },
  paid: {
    icon: Banknote,
    textKey: 'payment.status.paid',
    className: 'bg-green-50 text-green-600 hover:bg-green-100'
  },
  overdue: {
    icon: AlertCircle,
    textKey: 'payment.status.overdue',
    className: 'bg-red-50 text-red-600 hover:bg-red-100'
  },
  overdue_reminded: {
    icon: Bell,
    textKey: 'payment.status.overdue_reminded',
    className: 'bg-orange-50 text-orange-600 hover:bg-orange-100'
  }
} as const;

interface PaymentStatusBadgeProps {
  status: PaymentStatus;
  onClick?: () => void;
  asChild?: boolean;
}

export const PaymentStatusBadge: React.FC<PaymentStatusBadgeProps> = ({ status, onClick, asChild = false }) => {
  const { t } = useTranslation();
  const config = STATUS_CONFIG[status];

  if (!config) {
    console.error(`Invalid payment status: ${status}`);
    return null;
  }

  const { icon: Icon, textKey, className } = config;
  const sharedProps = {
    onClick,
    className: `inline-flex items-center gap-1.5 px-3 py-1 rounded-full text-xs font-medium transition-colors duration-200 ${className} ${onClick ? 'cursor-pointer' : 'cursor-default'}`
  };

  const content = (
    <>
      <Icon className="w-3.5 h-3.5" />
      {t(textKey)}
    </>
  );

  if (asChild) {
    return (
      <div {...sharedProps}>
        {content}
      </div>
    );
  }

  return (
    <button
      type="button"
      {...sharedProps}
    >
      {content}
    </button>
  );
}; 